// URL/API contract for sort keys and picker column ids. 'name' (fixed primary) and Country (sorting
// would need the localized name, not the stored ISO code — unsupported by the backend, see
// locationPrismaRepository.adapter.ts) are both excluded from the optional catalogue.
export const LOCATION_SORT_KEYS = [
  'name',
  'street',
  'houseNumber',
  'addressDetails',
  'postalCode',
  'city',
  'stateRegion',
] as const;
export type LocationSortKey = (typeof LOCATION_SORT_KEYS)[number];

export const LOCATION_OPTIONAL_COLUMN_IDS = [
  'street',
  'houseNumber',
  'addressDetails',
  'postalCode',
  'city',
  'stateRegion',
  'country',
] as const;
export type LocationOptionalColumnId = (typeof LOCATION_OPTIONAL_COLUMN_IDS)[number];
